<template>
  <div class="main-page home_page_noar"
       style="padding:0"
       :class="isflat ? 'page-home-flat' : ''">
    <HomeHead />
    <div class="demo-panel__content grayscale">
      <div class="c-left">
        <div class="video-panel">
          <video controls
                 controlslist="nodownload"
                 id="videopanel"
                 class="video1"
                 poster="/img/banner/bg_video.jpg"
                 webkit-playsinline="true"
                 style="width: 100%; display: block; height:100%;">
            <source :src="currentVideo.video"
                    type="video/mp4">
          </video>
        </div>
        <ul class="c-left_items">
          <li :class="['p-item', 'c' + (index + 1)]"
              v-for="(items, index) in prolist[0].list"
              :key="'key-item' + index"
              @click="toNewUrl(items)">
            <div class="imgs"
                 v-if="items.icon">
              <img :src="items.icon"
                   alt="">
            </div>
            <div class="title">
              {{ items.title }}
            </div>
          </li>
        </ul>
      </div>
      <div class="c-center">
        <!-- 视频咨询 -->
        <template v-for="(items, index) in prolist[1].list">
          <div v-if="!items.isVideo"
               :class="['p-item', 'c' + (index + 1)]"
               :key="'key-item' + index"
               @click="toNewUrl(items)">
            <img :src="items.icon"
                 alt="">
            <div class="title">
              {{ items.title }}
            </div>
          </div>
          <VideoConsult :item="items"
                        v-else
                        height="3.76rem" />
        </template>
      </div>
      <div class="c-right">
        <div class="s-banner">
          <!-- 广告banner -->
          <HomeSwiper :slidesPerView="1"></HomeSwiper>
        </div>
        <div class="p-box">
          <div :class="['p-item', 'c' + (index + 1)]"
               v-for="(items, index) in prolist[2].list"
               :key="'key-item' + index"
               @click="toNewUrl(items)">

            <img :src="items.icon"
                 alt="">
            <div class="title">
              {{ items.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rightslide v-model="slide"
                @getClose="slide.show = false">
      <template slot="content">
        <div class="video-list grayscale">
          <div class="hts">普法视频</div>
          <ul>
            <li v-for="(item, index) in videoList"
                :key="'key-videolist-' + index"
                @click="playVideo(item, index)">
              <a href="javascript:;">
                <img :src="item.img[0]"
                     alt>
                <strong class="video-title">{{ item.title }}</strong>
                <!-- <p>{{item.type}} ∙ {{item.view}}次浏览</p> -->
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template slot="footer">
        <div class="btns yel grayscale"
             @click="slide.show = false">
          <button>返回</button>
        </div>
      </template>
    </Rightslide>
    <HomeFoot />
  </div>
</template>

<script>
import Rightslide from '@/components/RightSlide'
import api from '@/datas/js/api'
import HomeFoot from '@/components/home/HomeFoot'
import HomeHead from '@/components/home/HomeHead'
import HomeSwiper from '@/components/home/HomeSwiper'
import VideoConsult from '@/components/home/VideoConsult'
import Vue from 'vue'
export default {
  components: {
    Rightslide,
    HomeFoot,
    HomeHead,
    HomeSwiper,
    VideoConsult
  },
  data () {
    return {
      advertisinglist: [],
      slide: {
        show: false
      },
      user: '',
      password: '',
      dialog: {
        show: false,
        title: '',
        type: '',
        cancelBtn: '返回'
      },

      currentVideo: '',
      videoList: [],
      pointConfig: '',
      isflat: false, // 是否是平板
      prolist: {
        0: {
          list: [
            {
              title: '普法视频',
              law: true,
              icon: '/img/ui/videohome/icon_video.png'
            },
            {
              title: '企业法治体检',
              isexam: true,
              icon: '/img/ui/videohome/icon_exam.png'
            },
            {
              title: '法律法规查询',
              path: '/law',
              icon: '/img/ui/videohome/icon_law.png'
            }
          ]
        },
        1: {
          list: [
            {
              title: '视频咨询律师',
              path: '/video',
              isVideo: true,
              icon: '/img/ui/videohome/icon_videozixun_90.png'
            },
            {
              title: '精准法律咨询',
              origin: 'advisory',
              icon: '/img/ui/videohome/icon_advisory.png',
            },
            {
              title: '留言咨询',
              path: '/service/10',
              icon: '/img/ui/videohome/message.png'
            },

          ]
        },
        2: {
          list: [
            {
              title: '法律援助',
              path: '/service/6',
              icon: '/img/ui/videohome/icon_aid.png'
            },
            {
              title: '人民调解',
              path: '/service/0',
              icon: '/img/ui/videohome/icon_tiaojie.png'
            },
            {
              title: '公证服务',
              path: '/service/2',
              icon: '/img/ui/videohome/icon_gongzheng.png'
            },
            {
              title: '司法鉴定',
              path: '/service/3',
              icon: '/img/ui/videohome/icon_jianding.png'
            },
            {
              title: '法律文书模板',
              path: '/service/11',
              icon: '/img/ui/videohome/icon_wenshu.png'
            },
            {
              title: '全部服务',
              path: '/allservice',
              icon: '/img/ui/videohome/icon_allservice.png'
            }
          ]
        },
      },
      play: 0,
      isAutoPlay: false
    }
  },

  computed: {
    technical () {
      const point = this.$store.state.device.point.config && JSON.parse(this.$store.state.device.point.config)
      const config = this.$store.state.device.config.base_config && JSON.parse(this.$store.state.device.config.base_config)
      let title = ''
      try {
        if (point && point.footer) {
          title = point.footer === undefined ? '律品汇科技（北京）有限公司' : point.footer
        } else if (config && config.footer) {
          title = config.footer === undefined ? '律品汇科技（北京）有限公司' : config.footer
        } else if (point && point.footer === '') {
          title = 'hide'
        } else if (config && config.footer === '') {
          title = 'hide'
        } else {
          title = '律品汇科技（北京）有限公司'
        }
        return title
      } catch (error) {
        console.log(error)
        return '律品汇科技（北京）有限公司'
      }
    }
  },

  watch: {
    play (val) {
      if (val === 1) {
        this.setAutoplay()
      }
      const video = document.querySelector("#videopanel")
      console.log(val, this.isAutoPlay, 'val', video.autoplay, 'video.paused', video.paused)
      if (val === 0 && this.isAutoPlay) {
        console.log('自动播放停止')
        // if (!video.paused) {
        this.setAutoplayEnd()
        // }
      }
    }
  },
  async created () {

    const StateDevice = this.$store.state.device
    if (!StateDevice.point) {
      await this.$store.dispatch('device/getData')
    }
    if (!StateDevice.point.geography) {
      this.$router.push('/initial')
    }

    const point = StateDevice.point
    this.pointConfig = point && point.config ? JSON.parse(point.config) : ''
    console.log(this.pointConfig, 'this.pointConfig')

    this.qrurl = this.pointConfig && this.pointConfig.qr ? this.pointConfig.qr : ''
    let extconfig = StateDevice.config
    const pointcode = point.code
    extconfig = extconfig && extconfig.extra_config ? JSON.parse(extconfig.extra_config) : ''
    console.log(extconfig, 'extconfig')
    if (extconfig.config) {
      // 获取广告banner
      this.advertisinglist = extconfig.config[pointcode] && extconfig.config[pointcode].banner && extconfig.config[pointcode].banner.length ? extconfig.config[pointcode].banner : extconfig.config['banner']
      console.log(this.advertisinglist, 'this.advertisinglist')
      /**
        * 广告位banner有一张图片不显示
        * 目前未确定原因
        * 暂时从列表中去掉这张图片，保证不会出现空白的情况
        */
      // this.advertisinglist.map((v, i) => {
      //   if (v.img === '/img/ui/home/advertising2.png') {
      //     this.advertisinglist.splice(i, 1)
      //   }
      // })
    }
  },

  async mounted () {
    const point = this.$store.state.device.point
    await this.getPufaVideo()
    this.currentVideo = this.videoList.length ? Object.assign(this.videoList[0], { index: 0 }) : ''

    // this.setTime()
    document.querySelector('#videopanel').src = this.currentVideo.video
    this.$nextTick(() => {
      //首页视频区域自动播放代码
      // document.querySelector('#videopanel').play()
      // document.querySelector('#waitAudio').src = ''
      // document.querySelector('#waitAudio').pause()
      document.querySelector('#videopanel').addEventListener('ended', () => {
        /**
         * 监听到播放结束后
         * 自动切换下一个视频
         * 以下为边界判断
         * 视频列表不能为空，视频只有一条时加上循环播放
         * 视频列表大于1条时，loop整个视频列表
         * currentVideo作为对象进行存储，提供暂停时需要的信息展示
         */
        if (this.videoList.length === 1) {
          document.querySelector('#videopanel').loop = 'loop'
        } else {
          const idx = this.currentVideo.index + 1 === this.videoList.length ? 0 : this.currentVideo.index + 1
          this.currentVideo = Object.assign(this.videoList[idx], { index: idx })
          document.querySelector('#videopanel').src = this.currentVideo.video
          if (point && point.isCycle || this.play === 1) {
            document.querySelector('#videopanel').play()
            const machineId = this.$store.state.device.point.no
            this.$get(`/pufa/post/?post_id=${this.videoList[idx].id}&machine_id=${machineId}&platform=ZD`)

          }
        }
      }, false)
    })
  },
  methods: {
    async setTime () {
      const { result } = await this.$get('/pufa/post/play/')
      this.play = result.play || 0
      if (result.play === 1) {
        this.isAutoPlay = true
      }
      setTimeout(() => {
        this.setTime()
      }, 1000 * 60)
    },
    setAutoplay () {
      this.$nextTick(() => {
        document.querySelector('#videopanel').autoplay = true
        if (this.videoList.length) {
          this.playVideo(this.videoList[0], 0)
        }
      })
    },
    setAutoplayEnd () {
      document.querySelector('#videopanel').pause()
      document.querySelector('#videopanel').autoplay = false
      document.querySelector('#waitAudio').src = ''
      document.querySelector('#waitAudio').pause()
      this.isAutoPlay = false
    },
    playVideo (item, index) {
      // play video
      this.slide.show = false
      this.currentVideo = Object.assign(item, { index })
      this.$get(`/pufa/post/?post_id=${item.id}&machine_id=${machineId}&platform=ZD`)

      this.$nextTick(() => {
        document.querySelector('#videopanel').src = item.video
        document.querySelector('#videopanel').play()
        document.querySelector('#waitAudio').src = ''
        document.querySelector('#waitAudio').pause()
      })
    },
    toNewUrl (item) {
      if (item && item.law) {
        this.slide.show = true
      }
      if (item && item.origin === 'advisory') {
        this.toAdvisorys()
      }
      if (item && item.path === '/law') {
        this.toLaw()
        return
      }
      if (item.iscalc) {
        this.toCalc()
      }
      if (item.isexam) {
        this.toExam()
      }
      if (item && item.path) {
        this.$router.push(item.path)
      }
    },

    async getPufaVideo () {
      const { result, status } = await this.$get(`${api.list}5fd17c657edc0146d49338eb`)
      if (status) {
        this.videoList = result.data.items
      }
    }
  },

}
</script>

<style lang="stylus" scoped>
.home_page_noar
  position relative
  box-sizing border-box
  padding 0.44rem 0 0
  overflow hidden
  &.page-home-flat
    padding-top 1rem
  footer p
    text-align center
    font-size 0.14rem
    color #7b79a7
    margin-top 0.2rem
    // margin-bottom 0.45rem
    .c1
      margin-right 0.2rem
    .c2
      margin-left 0.2rem
  .abut-us-panel
    position relative
    width 8rem
    .title
      font-size 0.3rem
      font-weight 600
      padding 0.15rem 0
    .company-erweima
      position absolute
      top 0.1rem
      right 0
      text-align center
      p
        padding 0.1rem 0
        font-size 0.16rem
    .company-name
      height 0.8rem
      display flex
      padding 0.1rem 0
      flex-direction column
      justify-content space-between
      h1
        font-size 0.24rem
      h3
        color #ff6700
    .company-info-panel
      line-height 1.6
      padding 0.2rem 0
  .header_home
    display flex
    justify-content space-between
    align-items center
    margin-bottom 0.56rem
    .c-left
      display flex
      align-items center
      color #fff
      .logo
        margin-right 0.3rem
        flex-shrink 0
        height 0.73rem
      .qr
        display flex
        align-items center
        font-size 0.14rem
        img
          margin-right 0.15rem
        strong
          display block
          font-size 0.18rem
          margin-bottom 0.02rem
      .phone
        margin-left 0.2rem
        display flex
        align-items center
        font-size 0.14rem
        img
          width 0.6rem
          margin-right 0.14rem
        strong
          font-size 0.3rem
          font-style italic
      .performance
        margin-left 0.2rem
        a
          display block
    .c-right
      display flex
      align-items center
      color #e3edff
      font-size 0.18rem
      .r-help, .r-suggest
        display flex
        align-items center
      .r-help
        margin-right 0.48rem
      img
        margin-right 0.1rem
        &.help
          width 0.24rem
        &.suggest
          width 0.2rem
  .demo-panel__content
    display flex
    padding 0 0.6rem
    justify-content space-between
    .c-left
      width 8.94rem
      height 5.71rem
      .video-panel
        margin 0
        width 8.93rem
        height 5.71rem
        background-color rgba(0, 0, 0, 0.5)
        margin-bottom 0.15rem
      .c-left_items
        display flex
        justify-content space-between
        .p-item
          width 2.88rem
          height 1.81rem
          color #fff
          font-size 0.24rem
          text-align center
          &.c1
            background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
          &.c2
            background-image linear-gradient(-180deg, #007ae3 0%, #00b0ee 100%)
            .imgs img
              width 0.65rem
          &.c3
            background-image linear-gradient(-180deg, #0066e5 0%, #4798fc 100%)
          .imgs
            margin 0.35rem 1.09rem 0.1rem
            width 0.75rem
            height 0.76rem
            img
              width 100%
              display block
              margin 0 auto
    .c-center
      width 2.88rem
      /deep/.home-video-consult
        margin-bottom 0.14rem
        img
          width 1.6rem
        .title
          margin-top 0.1rem
      .p-item
        color #fff
        font-size 0.24rem
        text-align center
        margin-bottom 0.14rem
        &.c1
          height 3.76rem
          background-image linear-gradient(-180deg, #505efa 0%, #599bff 100%)
          img
            margin 0.8rem 0 0.1rem
            width 1.24rem
          .title
            margin-top 0.1rem
        &.c2
          height 1.81rem
          background-image linear-gradient(-180deg, #e8822e 0%, #ffaa54 100%)
          img
            margin 0.31rem 0 0
            width 0.77rem
            height 0.9rem
        &.c3
          height 1.81rem
          background-image linear-gradient(-180deg, #505efa 0%, #599bff 100%)
          img
            margin 0.36rem 0 0.12rem
            width 0.76rem
    .c-right
      width 5.9rem
      .s-banner
        height 1.81rem
        margin-bottom 0.15rem
        img
          width 100%
      .p-box
        display flex
        justify-content space-between
        flex-wrap wrap
        .p-item
          color #fff
          font-size 0.24rem
          text-align center
          margin-bottom 0.14rem
          width 2.88rem
          height 1.81rem
          &.c1
            background-image linear-gradient(-180deg, #e3464e 0%, #fd767c 100%)
            img
              margin 0.4rem 0 0.1rem
              width 0.77rem
              height 0.7rem
          &.c2
            background-image linear-gradient(-180deg, #8d38d3 0%, #c653f1 100%)
            img
              margin 0.4rem 0 0.1rem
              width 0.99rem
              height 0.69rem
          &.c3
            background-image linear-gradient(-180deg, #007ae3 0%, #07abe5 100%)
            img
              margin 0.4rem 0 0
              width 0.69rem
              height 0.76rem
          &.c4
            background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
            img
              margin 0.4rem 0 0
              width 0.73rem
              height 0.79rem
          &.c5
            background-image linear-gradient(-180deg, #24ad5d 0%, #1ed96c 100%)
            img
              margin 0.4rem 0 0.08rem
              width 0.74rem
              height 0.73rem
          &.c6
            background-image linear-gradient(-180deg, #e96137 0%, #f88360 100%)
            img
              margin 0.4rem 0 0.15rem
              width 0.63rem
              height 0.65rem
  .video-list
    padding 0.3rem 0 0 0.3rem
    .hts
      font-size 0.36rem
      font-weight bold
    ul
      display flex
      flex-wrap wrap
      padding 0.3rem 0
      li
        width 50%
        margin-bottom 0.3rem
        a
          display block
          margin-right 0.3rem
          color #333
          img
            width 100%
            min-height 2.1rem
            max-height 2.1rem
            border-radius 0.1rem
            overflow hidden
            object-fit cover
            display block
          strong
            padding-top 0.2rem
            font-size 0.24rem
            display -webkit-box
            -webkit-box-orient vertical
            -webkit-line-clamp 1
            overflow hidden
          p
            padding-top 0.1rem
            font-size 0.18rem
            color #666666
.login-input
  font-size 0.26rem
  line-height 1
  height 0.8rem
.input-label
  font-size 0.3rem
  line-height 0.8rem
.login-btns
  color #fff !important
.login-row
  margin-bottom 0.2rem
.setting-btn
  text-decoration none
  color #fff
  margin-left 0.4rem
</style>
